<template>
  <div class="content album-add-page album-studio" :aria-busy="showCreateProgress">
    <el-form
        :model="createAlbumRequest"
        :rules="rules"
        ref="createAlbumRequest"
        label-width="120px"
        class="demo-ruleForm album-form"
    >
      <div class="page-header-card">
        <div class="album-heading">
        <div class="album-heading__icon"><i class="el-icon-picture-outline" aria-hidden="true" /></div>
        <div>
          <span class="album-heading__eyebrow">THƯ VIỆN ẢNH</span>
          <h2 class="page-title">Tạo album mới</h2>
          <p class="page-description">
            Điền thông tin album, chọn đối tượng hiển thị và tải ảnh lên theo đúng giới hạn hệ thống.
          </p>
        </div>
      </div>
        <div class="header-badges">
          <div class="summary-badge">
            <span class="summary-badge__label">Đối tượng</span>
            <strong class="summary-badge__value">
              {{ createAlbumRequest.selectObject === 'student' ? 'Lớp' : 'Trường' }}
            </strong>
          </div>
        </div>
      </div>

      <div class="form-shell">
        <div class="album-form-main">
          <section class="section-card album-info-section">
            <div class="section-heading">
              <h3 class="section-title"><i class="el-icon-document" aria-hidden="true" />Thông tin album</h3>
              <p class="section-description">Nhập thông tin cơ bản để tạo album mới.</p>
            </div>

            <el-row :gutter="20">
              <el-col :xs="24" :md="12">
                <el-form-item class="field-item" label="Tên album" prop="albumName">
                  <el-input
                      v-model="createAlbumRequest.albumName"
                      placeholder="Nhập tên album"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :md="12">
                <el-form-item class="field-item" label="Đối tượng">
                  <el-select
                      popper-class="album-studio-popper"
                      @change="handleChangeObject"
                      v-model="createAlbumRequest.selectObject"
                      placeholder="Chọn đối tượng"
                      class="full-width"
                  >
                    <el-option
                        v-for="item in listSelectObject"
                        :key="item.id"
                        :label="item.label"
                        :value="item.value"
                    >
                      <span>{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item class="description-item" label="Mô tả" prop="desc">
              <el-input
                  :rows="4"
                  v-model="createAlbumRequest.albumDescription"
                  placeholder="Nhập mô tả cho album"
                  type="textarea"
              ></el-input>
            </el-form-item>
          </section>

          <section v-if="createAlbumRequest.selectObject === 'student'" class="section-card album-audience-section">
            <div class="section-heading section-heading--space-between">
              <div>
                <h3 class="section-title"><i class="el-icon-user" aria-hidden="true" />Phạm vi học sinh</h3>
                <p class="section-description">Chọn học sinh áp dụng cho album theo từng lớp.</p>
              </div>

              <Phase2ActionButton
                  @click="clickSelectStudent"
                  type="primary"
                  icon="el-icon-user"
                  class="student-select-button"
              >
                Chọn học sinh trong lớp
              </Phase2ActionButton>
            </div>

            <div class="student-list-panel">
              <div class="student-list-panel__header">
                <div>
                  <h4 class="student-list-title">Danh sách học sinh</h4>
                  <span class="student-list-subtitle">Đã chọn {{ createAlbumRequest.kids.length }} học sinh</span>
                </div>
                <el-input
                    v-if="createAlbumRequest.kids && createAlbumRequest.kids.length"
                    v-model="selectedStudentSearch"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="Tìm theo tên hoặc lớp"
                    label="Tìm học sinh đã chọn"
                    class="student-list-search"
                />
                <span v-if="selectedStudentSearch.trim()" class="student-search-count" role="status">
                  Tìm thấy {{ filteredSelectedKids.length }} học sinh
                </span>
              </div>

              <div v-if="createAlbumRequest.kids.length === 0" class="student-empty-state">
                <i class="el-icon-user-solid student-empty-state__icon"></i>
                <div class="student-empty-state__title">Chưa có học sinh nào được chọn</div>
                <div class="student-empty-state__desc">
                  Nhấn <strong>Chọn học sinh trong lớp</strong> để thêm học sinh vào album này.
                </div>
              </div>

              <div v-else-if="filteredSelectedKids.length === 0" class="student-search-empty" role="status">
                Không tìm thấy học sinh phù hợp.
              </div>

              <div v-else class="answer_apply">
                <div v-for="(kid, index) in filteredSelectedKids" :key="index" class="kid-row">
                  <div class="kid-row__icon-wrap">
                    <i class="el-icon-circle-check kid-row__icon"/>
                  </div>
                  <div class="kid-row__content">
                    <div class="kid-row__name">{{ kid.kidsName }}</div>
                    <div class="kid-row__meta">
                      {{ parseKidStatusVietnamese(kid.statusKids) }} • {{ kid.className }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <section class="section-card album-upload-section">
          <div class="section-heading">
            <h3 class="section-title"><i class="el-icon-upload" aria-hidden="true" />Hình ảnh album</h3>
            <p class="section-description">Kéo thả hoặc chọn ảnh từ máy, kiểm tra ảnh trước khi lưu album.</p>
          </div>

          <div class="upload-toolbar">
            <div class="upload-left">
              <div class="upload-note-card">
                <span class="upload-note-card__label">Giới hạn</span>
                <strong class="upload-note-card__value">{{ "Tối đa " + albumMaxNumber + " ảnh" }}</strong>
              </div>

              <div class="selected-summary">
                <template v-if="fileList && fileList.length > 0">
                  <img :src="getPreview(fileList[0])" class="selected-summary__thumb" alt="ảnh"/>
                  <div class="selected-summary__text">{{ fileList.length }} ảnh đã chọn</div>
                  <el-button type="text" @click="clearSelected" class="clear-selected">Xóa</el-button>
                </template>
                <template v-else>
                  <div class="selected-summary__empty">Chưa có ảnh</div>
                </template>
              </div>
            </div>

            <div class="upload-right">
              <div class="progress-wrap">
                <el-progress
                    v-if="showProgress"
                    class="upload-progress"
                    :percentage="percentage"
                    :color="colors"
                ></el-progress>
                <div v-if="showProgress" class="progress-label">{{ percentage }}%</div>
              </div>
            </div>
          </div>

          <el-upload
              action="#"
              drag
              list-type="picture-card"
              :auto-upload="false"
              ref="upload"
              :file-list="fileList"
              :on-change="handleChangePicture"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="albumMaxNumber"
              :on-exceed="handleExceed"
              class="upload-area"
          >
            <template #default>
              <div class="upload-trigger">
                <i class="el-icon-upload upload-trigger__icon" aria-hidden="true"></i>
                <strong class="upload-trigger__text">Kéo thả ảnh vào đây</strong>
                <span class="upload-trigger__description">Chọn nhiều ảnh cùng lúc hoặc bấm để chọn từ máy</span>
                <span class="upload-trigger__button"><i class="el-icon-plus" aria-hidden="true" /> Chọn ảnh từ máy</span>
              </div>
            </template>
            <template #file="{ file }">
              <div class="container_image_upload">
                <TagFlag title="Mới"/>
                <img class="el-upload-list__item-thumbnail" :src="getPreview(file)" alt="Ảnh mới"/>
                <div class="upload-thumbnail-actions">
                  <button type="button" class="upload-thumbnail-action" :aria-label="'Xem ảnh ' + file.name" title="Xem ảnh" @click.stop="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in" aria-hidden="true"></i>
                  </button>
                  <button v-if="!disabled" type="button" class="upload-thumbnail-action upload-thumbnail-action--delete" :aria-label="'Bỏ ảnh ' + file.name" title="Bỏ ảnh" @click.stop="handleRemove(file)">
                    <i class="el-icon-delete" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </template>
          </el-upload>

          <div class="upload-help-text">
            JPG/PNG, tối đa 5MB/ảnh · Tối đa {{ albumMaxNumber }} ảnh
          </div>
        </section>

        <el-dialog class="album-studio-upload-preview" title="Xem ảnh mới" width="70%" :visible.sync="dialogVisible" top="32px">
          <img width="100%" :src="dialogImageUrl" alt/>
        </el-dialog>
      </div>

      <div class="actions-wrap">
        <Phase2ActionButton
            type="primary"
            size="small"
            :loading="loadingButton"
            :disabled="loadingButton || compressingCount > 0"
            @click="submitUpload('createAlbumRequest')"
            icon="el-icon-circle-check"
        >
          Lưu thay đổi
        </Phase2ActionButton>

        <router-link
            to="/album-v2"
            class="router-link cancel-link"
        >
          <Phase2ActionButton
              type="default"
              size="small"
              icon="el-icon-circle-close"
              @click="createEmployeeDialog()"
          >
            Hủy
          </Phase2ActionButton>
        </router-link>
      </div>
    </el-form>

    <div
        v-if="showCreateProgress"
        class="album-create-progress-overlay album-studio-progress"
        role="status"
        aria-live="polite"
    >
      <div class="album-create-progress-card">
        <i class="el-icon-loading album-create-progress-card__icon"></i>
        <h3 class="album-create-progress-card__title">{{ createProgressTitle }}</h3>
        <p class="album-create-progress-card__message">{{ createProgressMessage }}</p>
        <el-progress
            :percentage="percentage"
            :color="colors"
            :show-text="false"
            class="album-create-progress-card__bar"
        ></el-progress>
        <div class="album-create-progress-card__percent">{{ percentage }}%</div>
        <p class="album-create-progress-card__note">Vui lòng không đóng trang trong quá trình xử lý.</p>
      </div>
    </div>

    <AddStudentInAlbumDialog
        :getAppTypeUserLogin="getAppTypeUserLogin"
        :isAddStudentInAlbumDialog="isAddStudentInAlbumDialog"
        @closeDialog="closeAddStudentInAlbumDialog"
        @updateIdKidApply="updateIdKidApply"
        @confirmData="handleConfirmKidsApply"
    />
  </div>
</template>

<script>
import "./styles/album-studio.scss";
import AlbumService from "./services/AlbumService";
import pica from 'pica';
import {mapState} from "vuex";
import TagFlag from "@/views/tag/TagFlag.vue";
import albumService from "./services/AlbumService";
import AddStudentInAlbumDialog from "./AddStudentInAlbumDialog.vue";
import parseInfoKidVietnameseMixin from "@/global/mixinKid/parseInfoKidVietnamese.mixin";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import Phase2ActionButton from "@/components/common/phase2/Phase2ActionButton.vue";

export default {
  components: {
    AddStudentInAlbumDialog,
    TagFlag,
    Phase2ActionButton,
  },
  data() {
    return {
      selectedStudentSearch: "",
      colors: [
        {color: "#9bd4dc", percentage: 20},
        {color: "#65b6b5", percentage: 40},
        {color: "#4b91c5", percentage: 60},
        {color: "#477ab8", percentage: 80},
        {color: "#6f79bd", percentage: 100},
      ],
      percentage: 0,
      loadingButton: false,
      showCreateProgress: false,
      createProgressTitle: "Đang tạo album",
      createProgressMessage: "Đang lưu thông tin album...",
      createAlbumRequest: {
        albumName: "",
        albumDescription: "",
        albumType: "",
        albumApprovalDefault: false,
        idSchoolApproval: "",
        createdBy: "",
        createdDate: "",
        schoolApprovalDate: "",
        urlPictureFirst: "",
        pictureNumber: "",
        pictureApprovedNumber: "",
        idClass: "",
        idSchool: "",
        alistPictureList: [],
        fileList: [],
        selectObject: "school",
        listIdKidApply: [],
        classes: [],
        kids: [],
      },
      rules: {
        albumName: [
          {
            required: true,
            message: "Tên Album không được được để trống",
            trigger: "blur",
          },
        ],
        idClass: [
          {
            required: true,
            message: "Lớp không được để trống",
            trigger: "blur",
          },
        ],
      },
      selectedFiles: undefined,
      currentFile: undefined,
      fileInfos: [],
      layout: "sizes, prev, pager, next",
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisiblePic: false,
      indexSrc: "",
      disabled: false,
      showCreateDialog: false,
      showUpdateDialog: false,
      idList: [],
      qualityPicture: "",
      widthPicture: "",
      srcs: [
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%203.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2014.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%202.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%2013.jpg",
        "http://upload.onekids.edu.vn/id1/2020/T08/album_anh/%207.jpg",
      ],
      imgUrl: "",
      albumMaxNumber: 0,
      maxSizeListImage: null,
      showProgress: false,
      isAddStudentInAlbumDialog: false,
      idKidApply: [],
      compressingCount: 0,
      compressPromises: [],
      picaResizer: null,
    };
  },
  computed: {
    filteredSelectedKids() {
      const normalize = value => String(value || "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/đ/g, "d")
          .replace(/Đ/g, "D")
          .toLowerCase();
      const query = normalize(this.selectedStudentSearch).trim();
      const kids = this.createAlbumRequest.kids || [];
      return query
          ? kids.filter(kid => normalize(kid.kidsName).includes(query)
              || normalize(kid.className).includes(query))
          : kids;
    },
    ...mapState('classStore', ['classInTeacher']),
    ...mapState('classStore', ['classListCommon']),

    listClass() {
      if (this.getAppTypeUserLogin === "plus") {
        return this.classListCommon;
      } else if (this.getAppTypeUserLogin === "teacher") {
        return this.classInTeacher;
      }
      return [];
    },
    // eslint-disable-next-line vue/return-in-computed-property
    listSelectObject() {
      if (this.getAppTypeUserLogin === "plus") {
        return [
          { id: 1, value: "school", label: "Trường" },
          { id: 2, value: "student", label: "Lớp" },
        ];
      } else if (this.getAppTypeUserLogin === "teacher") {
        return [
          { id: 2, value: "student", label: "Lớp" },
        ];
      }
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
  },
  mixins: [
    parseInfoKidVietnameseMixin,
  ],
  created() {
    this.picaResizer = pica({
      features: ['js', 'wasm', 'ww'],
    });
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    this.getAlbumMaxNumber();
    this.getSyConfigPicture();
    this.fetchSizeListImage();
    if (this.getAppTypeUserLogin === "plus") {
      this.createAlbumRequest.selectObject = "school";
    } else if (this.getAppTypeUserLogin === "teacher") {
      this.createAlbumRequest.selectObject = "student";
    }
    this.handleChangeObject();
  },
  methods: {
    getPreview(file) {
      if (!file) return '';
      const url = file.url || file.thumbUrl;
      if (url) return url;
      if (file.raw && file.raw instanceof File) {
        if (!this._createdPreviews) this._createdPreviews = {};
        if (!this._createdPreviews[file.uid]) {
          this._createdPreviews[file.uid] = URL.createObjectURL(file.raw);
        }
        return this._createdPreviews[file.uid];
      }
      return '';
    },

    formatSize(bytes) {
      if (!bytes) return '';
      const kb = 1024;
      if (bytes < kb) return bytes + ' B';
      const mb = kb * 1024;
      if (bytes < mb) return (bytes / kb).toFixed(1) + ' KB';
      return (bytes / mb).toFixed(1) + ' MB';
    },

    clearSelected() {
      if (this._createdPreviews) {
        this.fileList.forEach(f => {
          const url = this._createdPreviews[f.uid];
          if (url) {
            try { URL.revokeObjectURL(url); } catch (e) { /* ignore */ }
            delete this._createdPreviews[f.uid];
          }
        });
      }
      this.fileList = [];
      if (this.createAlbumRequest && Array.isArray(this.createAlbumRequest.fileList)) {
        this.createAlbumRequest.fileList = [];
      }
      try { this.$refs.upload.clearFiles(); } catch (e) { /* ignore */ }
    },
    clearAllSelected() {
      this.clearSelected();
    },
    handleChangeObject(){
      if (this.createAlbumRequest.selectObject === "school") {
        this.createAlbumRequest.listIdKidApply = [];
        this.createAlbumRequest.classes = [];
        this.createAlbumRequest.kids = [];
      }
    },
    clickSelectStudent(){
      this.isAddStudentInAlbumDialog = true;
    },
    closeAddStudentInAlbumDialog(){
      this.isAddStudentInAlbumDialog = false;
    },
    updateIdKidApply(newList) {
      this.idKidApply = newList;
    },
    handleConfirmKidsApply(value) {
      this.createAlbumRequest.classes = value.classesApply;
      this.createAlbumRequest.kids = value.kidsApply;
      this.createAlbumRequest.listIdKidApply = [];
      for (let i = 0; i < this.createAlbumRequest.kids.length; i++) {
        this.createAlbumRequest.listIdKidApply.push(this.createAlbumRequest.kids[i].idKid);
      }
      this.closeAddStudentInAlbumDialog();
    },
    getSyConfigPicture() {
      AlbumService.getSyConfigPicture().then((response) => {
        this.qualityPicture = response.data.data.qualityPicture;
        this.widthPicture = response.data.data.widthPicture;
      });
    },
    increase() {
      this.interval = window.setInterval(() => {
        this.percentage += 5;
        if (this.percentage > 90) {
          this.percentage = 90;
        }
      }, 50);
    },
    stopIncrease() {
      clearInterval(this.interval);
      this.percentage = 100;
    },
    handleChangePicture(file, fileList) {
      this.fileList = fileList;
      this.createAlbumRequest.fileList = fileList;
      if (!file || !file.raw) {
        return false;
      }
      const isJPG = file.raw.type === "image/jpeg";
      const isPNG = file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG) {
        this.$message.error("Ảnh phải có dạng JPG hoặc PNG!");
        this.handleRemove(file);
        return false;
      }
      if (!isLt5M) {
        this.$message.error("Ảnh không thể vượt quá 5MB");
        this.handleRemove(file);
        return false;
      }
      return true;
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        const objectUrl = URL.createObjectURL(file);
        image.onload = () => {
          URL.revokeObjectURL(objectUrl);
          resolve(image);
        };
        image.onerror = (error) => {
          URL.revokeObjectURL(objectUrl);
          reject(error);
        };
        image.src = objectUrl;
      });
    },
    async compressImage(file, fileName, uid) {
      const image = await this.loadImage(file);
      const maxWidthConfig = parseInt(this.widthPicture);
      const maxWidth = Number.isFinite(maxWidthConfig) && maxWidthConfig > 0 ? maxWidthConfig : 1280;
      const ratio = Math.min(1, maxWidth / image.width);
      const targetWidth = Math.max(1, Math.round(image.width * ratio));
      const targetHeight = Math.max(1, Math.round(image.height * ratio));

      const sourceCanvas = document.createElement('canvas');
      sourceCanvas.width = image.width;
      sourceCanvas.height = image.height;
      const sourceContext = sourceCanvas.getContext('2d');
      sourceContext.drawImage(image, 0, 0);

      const resultCanvas = document.createElement('canvas');
      resultCanvas.width = targetWidth;
      resultCanvas.height = targetHeight;

      await this.picaResizer.resize(sourceCanvas, resultCanvas);

      const qualityConfig = parseInt(this.qualityPicture);
      const quality = Number.isFinite(qualityConfig) && qualityConfig > 0 ? Math.min(1, qualityConfig / 100) : 0.8;
      const outputType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
      const resultBlob = await this.picaResizer.toBlob(resultCanvas, outputType, quality);

      const lastDot = fileName.lastIndexOf('.');
      const originalFilename = lastDot > 0 ? fileName.substring(0, lastDot) : fileName;
      const extension = outputType === 'image/png' ? 'png' : 'jpg';
      const compressedFile = new File([resultBlob], `${originalFilename}_compressed.${extension}`, {type: outputType});
      compressedFile.uid = uid;
      return compressedFile;
    },
    tableHeaderColor() {
      return "background-color: var(--primary);color: #fff;font-weight: bold";
    },
    tableRowStyle({row}) {
      row.id;
    },
    submitUpload(fromData) {
      this.$refs[fromData].validate(async (valid) => {
        if (!valid) return;
        await this.createAlbumV2();
      });
    },

    async createAlbumV2() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.warning("Vui lòng chọn ít nhất một ảnh");
        return;
      }
      this.loadingButton = true;
      this.showProgress = true;
      this.showCreateProgress = true;
      this.percentage = 5;
      this.createProgressTitle = "Đang tạo album";
      this.createProgressMessage = "Đang lưu thông tin album và danh sách ảnh...";
      try {
        const pictures = this.fileList.map((file, index) => this.buildPictureMetadata(file, index));
        const payload = {
          albumName: this.createAlbumRequest.albumName,
          albumDescription: this.createAlbumRequest.albumDescription,
          selectObject: this.createAlbumRequest.selectObject,
          idClass: this.createAlbumRequest.selectObject === "school"
              ? 0
              : (this.createAlbumRequest.classes[0] || 0),
          classIds: this.createAlbumRequest.selectObject === "school"
              ? []
              : (this.createAlbumRequest.classes || []),
          listIdKidApply: this.createAlbumRequest.selectObject === "school"
              ? []
              : this.createAlbumRequest.listIdKidApply,
          pictures,
        };
        const response = await AlbumService.createAlbumV2(payload);
        const albumIdx = response.data.data;
        this.percentage = 10;
        this.createProgressTitle = "Đang tải ảnh lên";
        this.createProgressMessage = `Đang chuẩn bị ${this.fileList.length} ảnh...`;
        await this.uploadAlbumPicturesV2(albumIdx, pictures, this.fileList);
        this.percentage = 100;
        this.createProgressMessage = "Đã hoàn tất tạo album và lưu ảnh.";
        NotifyMessage.leftCornerNotificationSuccess("Thêm mới Album thành công!");
        await this.$router.push("/album-v2");
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError(
            error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : "Thêm mới Album thất bại");
      } finally {
        this.showProgress = false;
        this.showCreateProgress = false;
        this.percentage = 0;
        this.loadingButton = false;
      }
    },

    buildPictureMetadata(file, index) {
      const raw = file.raw || file;
      const token = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : `${Date.now()}_${file.uid || index}_${Math.random().toString(36).slice(2)}`;
      return {
        pictureId: token,
        fileName: raw.name || `${token}.jpg`,
        representative: index === 0,
      };
    },

    async uploadAlbumPicturesV2(albumIdx, pictures, fileList) {
      const uploadedObjectKeys = [];
      try {
        for (let i = 0; i < fileList.length; i++) {
          this.createProgressTitle = "Đang tải ảnh lên";
          this.createProgressMessage = `Đang nén và tải ảnh ${i + 1}/${fileList.length} ...`;
          this.percentage = Math.max(10, Math.round(10 + (i / fileList.length) * 80));
          const raw = fileList[i].raw || fileList[i];
          const compressed = await this.compressImage(raw, raw.name, pictures[i].pictureId);
          const thumbnail = await this.createThumbnail(compressed, pictures[i].pictureId);
          await this.uploadObjectToMinio(pictures[i], compressed, false, uploadedObjectKeys);
          await this.uploadObjectToMinio(pictures[i], thumbnail, true, uploadedObjectKeys);
          this.percentage = Math.max(10, Math.round(10 + ((i + 1) / fileList.length) * 85));
        }
      } catch (uploadError) {
        this.createProgressTitle = "Đang khôi phục ảnh";
        this.createProgressMessage = "Một ảnh tải lên MinIO bị lỗi, đang dọn dữ liệu đã tải...";
        this.percentage = 95;
        if (uploadedObjectKeys.length > 0) {
          try {
            await AlbumService.cleanupMinioObjectsV2(uploadedObjectKeys);
          } catch (cleanupError) {
            console.error("MinIO cleanup error:", cleanupError);
          }
        }
        const originals = fileList.map(file => file.raw || file);
        this.createProgressMessage = "Đang tạo ảnh compressed và thumbnail tại máy chủ...";
        await AlbumService.fallbackAlbumPicturesV2(
            albumIdx,
            pictures.map(picture => picture.pictureId),
            originals);
      }
    },

    async uploadObjectToMinio(picture, file, thumbnail, uploadedObjectKeys) {
      const response = await AlbumService.getMinioUploadUrlV2(
          picture.pictureId,
          picture.fileName,
          thumbnail);
      const uploadInfo = response.data.data;
      const objectKey = uploadInfo.objectKey;
      // Ghi nhận trước PUT để vẫn cleanup được khi mạng lỗi sau khi MinIO đã nhận bytes.
      uploadedObjectKeys.push(objectKey);
      const result = await fetch(uploadInfo.uploadUrl, {
        method: "PUT",
        headers: {"Content-Type": file.type || "image/jpeg"},
        body: file,
      });
      if (!result.ok) {
        throw new Error(`Upload MinIO thất bại: ${objectKey}`);
      }
    },

    async createThumbnail(compressedFile, pictureId) {
      const image = await this.loadImage(compressedFile);
      const maxWidth = 256;
      const ratio = Math.min(1, maxWidth / image.width);
      const targetWidth = Math.max(1, Math.round(image.width * ratio));
      const targetHeight = Math.max(1, Math.round(image.height * ratio));
      const sourceCanvas = document.createElement("canvas");
      sourceCanvas.width = image.width;
      sourceCanvas.height = image.height;
      sourceCanvas.getContext("2d").drawImage(image, 0, 0);
      const targetCanvas = document.createElement("canvas");
      targetCanvas.width = targetWidth;
      targetCanvas.height = targetHeight;
      await this.picaResizer.resize(sourceCanvas, targetCanvas);
      const outputType = compressedFile.type || "image/jpeg";
      const blob = await this.picaResizer.toBlob(targetCanvas, outputType, 0.8);
      const extension = outputType === "image/png" ? "png" : "jpg";
      return new File([blob], `thumbnail_${pictureId}.${extension}`, {type: outputType});
    },

    async savePictureAlbum(id, fileList) {
      const groupFile = this.groupFilesBySize(fileList);

      try {
        const uploadPromises = groupFile.map(async (child) => {
          const formData = new FormData();
          formData.append("idAlbum", id);
          formData.append("isCreate", true);

          child.forEach((file, i) => {
            formData.append(`fileList[${i}]`, file);
          });

          await AlbumService.savePictureAlbum(formData);
        });

        await Promise.all(uploadPromises);
        NotifyMessage.leftCornerNotificationSuccess("Thêm mới Album thành công!");
        await this.$router.push("/album-v2");
      } catch (error) {
        console.error(error);
        NotifyMessage.leftCornerNotificationError("Lỗi lưu ảnh!");
      } finally {
        this.showProgress = false;
        this.stopIncrease();
        this.loadingButton = false;
      }
    },

    groupFilesBySize(files) {
      const maxSize = this.maxSizeListImage * 1024 * 1024;
      let groups = [];
      let currentGroup = [];
      let currentSize = 0;

      for (let file of files) {
        const fileSize = file.size;
        if (currentSize + fileSize <= maxSize) {
          currentGroup.push(file);
          currentSize += fileSize;
        } else {
          groups.push(currentGroup);
          currentGroup = [file];
          currentSize = fileSize;
        }
      }

      if (currentGroup.length > 0) {
        groups.push(currentGroup);
      }

      return groups;
    },

    handleRemove(file) {
      if (this.$refs.upload && Array.isArray(this.$refs.upload.uploadFiles)) {
        const upIndex = this.$refs.upload.uploadFiles.findIndex(item => item.uid === file.uid);
        if (upIndex >= 0) {
          this.$refs.upload.uploadFiles.splice(upIndex, 1);
        }
      }
      const indexAlbumRequest = this.createAlbumRequest.fileList.findIndex(item => item.uid === file.uid);
      if (indexAlbumRequest >= 0) {
        this.createAlbumRequest.fileList.splice(indexAlbumRequest, 1);
      }
      const indexFile = this.fileList.findIndex(item => item.uid === file.uid);
      if (indexFile >= 0) {
        this.fileList.splice(indexFile, 1);
      }
      if (this._createdPreviews && this._createdPreviews[file.uid]) {
        try { URL.revokeObjectURL(this._createdPreviews[file.uid]); } catch (e) { /* ignore */ }
        delete this._createdPreviews[file.uid];
      }
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url || this.getPreview(file);
      this.dialogVisible = true;
    },
    createEmployeeDialog() {
      this.showCreateDialog = true;
    },
    handleExceed() {
      let textWarning = "Chỉ được phép chọn tối đa " + this.albumMaxNumber + " ảnh";
      this.$message.warning(textWarning);
    },
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`Bạn có chắc chắn muốn hủy ảnh ${file.name}?`);
    },

    getAlbumMaxNumber() {
      AlbumService.getAlbumMaxNumber()
          .then(response => {
            this.albumMaxNumber = response.data.data;
          })
          .catch(error => {
            console.error(error);
          });
    },

    fetchSizeListImage() {
      albumService.getSizeListImage()
          .then(res => this.maxSizeListImage = res.data.data)
          .catch(err => console.error(err));
    }
  },
};
</script>
